import { render, staticRenderFns } from "./ShippingCompany.vue?vue&type=template&id=838a8b30&"
import script from "./ShippingCompany.vue?vue&type=script&lang=js&"
export * from "./ShippingCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports